"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyLinearProgress = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));
/**
 * @deprecated This component should not be used. Use "LinearProgress" from "@mui/material/LinearProgress" instead
 */


const SskyLinearProgress = props => {
  return react_1.default.createElement(material_1.LinearProgress, {
    className: props.className,
    variant: props.variant,
    value: props.value
  });
};

exports.SskyLinearProgress = SskyLinearProgress;
exports.default = react_1.default.memo(SskyLinearProgress);